import React, { Fragment } from 'react'
import Header from '../Components/HomeComponents/Headear/Header'
import PaymentHistory from '../Components/UserComponents/PaymentHistory/PaymentHistory'

function PaymentHistoryPage() {
  return (
    <Fragment>
    <Header/>
    <PaymentHistory/>
</Fragment>
  )
}

export default PaymentHistoryPage